// extracted by mini-css-extract-plugin
export default {"emptyContainer":"speakers_emptyContainer__dnMeK","noRecord":"speakers_noRecord__4TUkR"};